import React from 'react'
import BlueHeading from '../other/common/BlueHeading'
import Heading from '../common/ui/Heading';

const SocialiteHero = () => {
  return (
    <>
      <div className="bg-center bg-cover bg-no-repeat bg-socialite-hero-bg-img px-4">
        <div className="max-w-[861px] mx-auto flex items-center justify-center flex-col py-[242px] max-xl:py-44 max-lg:py-32 max-md:py-24 max-sm:py-14">
          <BlueHeading
            lineClassOne="!bg-white"
            lineClassTwo="!bg-white"
            textClass="!text-white"
            text="Socialite "
          />
          <Heading
            children="Socialite – Service is True Duty"
            className="text-center text-white"
          />
        </div>
      </div>
    </>
  );
}

export default SocialiteHero